
// import client from "../../Client/Client";
// import { EditResponse } from "../../Interface/EditSignUp";

import { client } from "../../../Client/Client";
import { googleApi, manageClientServices, manageInvoiceServices, SignUpEndpoint } from "../../../Configs/BackendRoutes";
import { AIendpoint, backendUrl as URL } from "../../../Configs/Constant";

export const getDynamicDropdownData = async () => {
    const config = {
        method: 'GET',
        url: URL + SignUpEndpoint.GetDropdown,
        headers: {
            'Content-Type': 'application/json'
        },
        data: null
    };
    const response = await client(config);
    return response;
};

export const getRegionData = async () => {
    const config = {
        method: 'GET',
        url: URL + SignUpEndpoint.GetRegion,
        headers: {
            'Content-Type': 'application/json'
        },
        data: null
    };
    const response = await client(config);
    return response;
};

export const SaveSignUp = async (payload: any) => {
    const config = {
        method: 'POST',
        url: URL + SignUpEndpoint.SignUp,
        // url: URL + Endpoints.SignUp,
        headers: {
            'Content-Type': 'application/json'
        },
        data: payload
    };
    const response = await client(config);
    return response;
};

export const getContractorDetailsById = async (payload: any) => {
    const config = {
        method: 'POST',
        // url: URL + "",
        url: URL + manageClientServices.retrieveProfileData,
        headers: {
            'Content-Type': 'application/json'
        },
        data: payload
    };
    const response = await client(config);
    return response;
};

export const AIVerifyDoc = async (payload: any) => {
    const config = {
        method: 'POST',
        url: AIendpoint,
        headers: {
            'Content-Type': 'application/json'
        },
        data: payload
    };

    const response = await client(config);


    return response;
};

export const getSuggestion = async (data:any) => {
    const config = {
        method: 'POST',
        url: URL + googleApi.Suggestion,
        headers: {
            'Content-Type': 'application/json',
        },
        data
    };
    const response = await client(config);
    return response;
};
export const getSuggestionById = async (data: any) => {
    const config = {
        method: 'POST',
        url: URL + googleApi.PlaceSuggestion,
        headers: {
            'Content-Type': 'application/json',
        },
        data
    };
    const response = await client(config);
    return response;
};


export const UploadToS3 = async (payload: any) => {
    const config = {
        method: 'POST',
        url: URL + manageInvoiceServices.Document ,
        headers: {
            'Content-Type': 'application/json'
        },
        data: payload
    };
    
    const response = await client(config);
    return response;
};
